
import React from "react";
//@ts-ignore
import jMoment from "moment-jalaali";
import { useLanguage } from "../locals";

export const useDateChange = () => {
  jMoment.loadPersian({ usePersianDigits: true });
  const { isRtl } = useLanguage();

  function changeDateToPersian(Date: any) {
    return isRtl ? jMoment(Date).format("jYYYY-jMM-jDD HH:mm:ss") : Date;
  }
  
    function changeNumberToPersian(number:any) {
      const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  
      return isRtl ? number.toString().replace(/\d/g, (digit:any) => persianDigits[digit]):number
      
    };  

    
  return { changeDateToPersian,changeNumberToPersian };
};
